import { NewCommentForm } from '@components/ArtBoard/Threads/components/NewCommentForm'
import type { EditorValue } from '@octopus-do/octopus-editor'
import type { ID } from '@octopus-do/octopus-project-core'
import { CommentsActions } from '@store/reducers/comments'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

interface Props {
  threadId: ID
}

export const ReplyEditor: React.FC<Props> = ({ threadId }) => {
  const dispatch = useDispatch()

  // `author` is committed by the form, which owns the name field (OCT-5090);
  // it is '' for a member and for a guest who left it empty, and the backend
  // reads both as no name at all
  const onReply = (content: EditorValue, author: string) => {
    sendGtmEvent(GtmTriggerName.CREATE_THREAD)

    dispatch(
      CommentsActions.create({
        recipients: [],
        commentable: threadId,
        commentableType: 3,
        content: JSON.stringify(content),
        ...(author ? { author } : {}),
      })
    )
  }

  return (
    <div className={css.reply_editor}>
      <NewCommentForm autofocus onSubmit={onReply} />
    </div>
  )
}
